import axios from 'axios';
import { getAppVersion } from '../utils/version';

// Environment-aware base URL - uses the value from .env or defaults to root path
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-App-Version': getAppVersion(), // Add version header to all requests
    // Add stronger cache control headers
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    'Pragma': 'no-cache',
    'Expires': '0'
  },
  // Default timeout
  timeout: 30000, // 30 seconds
});

// Response interceptor for standardized error handling
apiClient.interceptors.response.use(
  // Success handler - pass response through
  response => {
    // Log successful responses for profile-related endpoints for debugging
    if (response.config.url?.includes('profile')) {
      console.log(`API Success (${response.status}) for ${response.config.url}:`, response.data);
    }
    return response;
  },
  
  // Error handler - enhance error with friendly messages
  error => {
    // Extract useful information from the error
    const status = error.response?.status;
    const data = error.response?.data;
    const url = error.config?.url;
    
    // Log detailed error information
    console.error(`API Error (${status}) for ${url}:`, data);
    
    // Create enhanced error object with user-friendly messages
    const enhancedError = {
      ...error,
      isApiError: true,
      status,
      message: data?.message || error.message || 'An unknown error occurred',
      friendlyMessage: getFriendlyErrorMessage(status, data)
    };
    
    return Promise.reject(enhancedError);
  }
);

// Add request interceptor for version parameter on GET requests
apiClient.interceptors.request.use(
  config => {
    // Add version parameter to GET requests to prevent caching
    if (config.method?.toLowerCase() === 'get') {
      config.params = {
        ...config.params,
        v: getAppVersion(), // Use version as cache-busting parameter
        t: new Date().getTime() // Add timestamp for stronger cache-busting
      };
    }
    
    // Log requests for profile-related endpoints for debugging
    if (config.url?.includes('profile')) {
      console.log(`API Request: ${config.method?.toUpperCase() || 'GET'} ${config.url}`, {
        params: config.params,
        data: config.data
      });
    }
    
    return config;
  },
  error => Promise.reject(error)
);

// Helper for user-friendly error messages
function getFriendlyErrorMessage(status, data) {
  switch (status) {
    case 400:
      return 'The request was invalid. Please check your information and try again.';
    case 401:
      return 'Your session has expired. Please log in again.';
    case 403:
      return 'You don\'t have permission to access this resource.';
    case 404:
      return 'The requested resource was not found.';
    case 422:
      return 'The data you submitted contains errors. Please check and try again.';
    case 429:
      return 'Too many requests. Please try again later.';
    case 500:
      return 'Something went wrong on our end. Please try again later.';
    case 502:
    case 503:
    case 504:
      return 'Our service is temporarily unavailable. Please try again later.';
    default:
      return data?.message || 'An unexpected error occurred. Please try again.';
  }
}

// Helper for making authenticated requests
export const withAuth = (token) => {
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  }
  return {};
};

export default apiClient;



/* Working June 8th 10:47 pm before update
import axios from 'axios';
import { getAppVersion } from '../utils/version';

// Environment-aware base URL - uses the value from .env or defaults to root path
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-App-Version': getAppVersion(), // Add version header to all requests
  },
  // Default timeout
  timeout: 30000, // 30 seconds
});

// Response interceptor for standardized error handling
apiClient.interceptors.response.use(
  // Success handler - pass response through
  response => response,
  
  // Error handler - enhance error with friendly messages
  error => {
    // Extract useful information from the error
    const status = error.response?.status;
    const data = error.response?.data;
    const url = error.config?.url;
    
    // Log detailed error information
    console.error(`API Error (${status}) for ${url}:`, data);
    
    // Create enhanced error object with user-friendly messages
    const enhancedError = {
      ...error,
      isApiError: true,
      status,
      message: data?.message || error.message || 'An unknown error occurred',
      friendlyMessage: getFriendlyErrorMessage(status, data)
    };
    
    return Promise.reject(enhancedError);
  }
);

// Add request interceptor for version parameter on GET requests
apiClient.interceptors.request.use(
  config => {
    // Add version parameter to GET requests to prevent caching
    if (config.method?.toLowerCase() === 'get') {
      config.params = {
        ...config.params,
        v: getAppVersion() // Use version as cache-busting parameter
      };
    }
    return config;
  },
  error => Promise.reject(error)
);

// Helper for user-friendly error messages
function getFriendlyErrorMessage(status, data) {
  switch (status) {
    case 400:
      return 'The request was invalid. Please check your information and try again.';
    case 401:
      return 'Your session has expired. Please log in again.';
    case 403:
      return 'You don\'t have permission to access this resource.';
    case 404:
      return 'The requested resource was not found.';
    case 422:
      return 'The data you submitted contains errors. Please check and try again.';
    case 429:
      return 'Too many requests. Please try again later.';
    case 500:
      return 'Something went wrong on our end. Please try again later.';
    case 502:
    case 503:
    case 504:
      return 'Our service is temporarily unavailable. Please try again later.';
    default:
      return data?.message || 'An unexpected error occurred. Please try again.';
  }
}

// Helper for making authenticated requests
export const withAuth = (token) => {
  if (token) {
    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    };
  }
  return {};
};

export default apiClient;

*/